import { AtomicBlockUtils, EditorState } from 'draft-js';
import { UPDATE_TEXT_EDITOR } from '../actions/update-text-editor';
import { SET_TEXT_EDITOR_ENTITY_DATA } from '../actions/set-text-editor-entity-data';
import { INSERT_TEXT_EDITOR_LINK } from '../actions/insert-text-editor-link';
import { INSERT_TEXT_EDITOR_ENTITY } from '../actions/insert-text-editor-entity';
import { REMOVE_TEXT_EDITOR_ENTITY } from '../actions/remove-text-editor-entity';
import { removeEntity, insertLink } from '../components/text-editor/modifiers/text-editor-utils';

const editorState = (state = null, { type, payload } = {}) => {
  switch (type) {
    case SET_TEXT_EDITOR_ENTITY_DATA: {
      const { entityData, entityKey } = payload;
      state.getCurrentContent().mergeEntityData(entityKey, entityData);

      return EditorState.forceSelection(state, state.getSelection());
    }

    case REMOVE_TEXT_EDITOR_ENTITY: {
      const { blockKey, entityKey } = payload;
      return removeEntity(state, blockKey, entityKey);
    }

    case INSERT_TEXT_EDITOR_LINK:
      return insertLink(state, payload.url);

    case INSERT_TEXT_EDITOR_ENTITY: {
      return AtomicBlockUtils.insertAtomicBlock(state, payload.entityKey, ' ');
    }

    default:
      return state;
  }
};

export default function textEditorReducer(state = {}, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_TEXT_EDITOR:
      return {
        ...state,
        [payload.identifier]: payload.editorState,
      };

    case INSERT_TEXT_EDITOR_LINK:
    case INSERT_TEXT_EDITOR_ENTITY:
    case SET_TEXT_EDITOR_ENTITY_DATA:
    case REMOVE_TEXT_EDITOR_ENTITY:
      return {
        ...state,
        [payload.identifier]: editorState(state[payload.identifier], action),
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/text-editor.js